// removed by extract-text-webpack-plugin
module.exports = {"default":"type__default___3pf1N bg-white","project":"type__project___3VzNE bg-snow","hint":"type__hint___zeKXr borderColor-smoke--d borderStyle-dashed borderWidth-1"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/Card/style/type.css
// module id = 141
// module chunks = 0 1